module.exports = __webpack_public_path__ + "img/ecp.4bfa675f.svg";